import { createFeatureSelector, createSelector } from '@ngrx/store';

import { merchandiseFeatureKey } from '../../../constants';
import { MarketingProductsState } from '../../models';
import { marketingProductsAdapter } from '../../reducers';

export const selectMerchandiseState =
  createFeatureSelector<MarketingProductsState>(merchandiseFeatureKey);

export const selectMarketingProducts = createSelector(
  selectMerchandiseState,
  (state) => state.marketingProducts,
);

export const { selectIds: selectAllMarketingProductIds } =
  marketingProductsAdapter.getSelectors(selectMarketingProducts);

export const selectIsProductMarketing = (productId: string) =>
  createSelector(selectAllMarketingProductIds, (productIds: string[]) =>
    productIds.includes(productId),
  );
